import { useContext, useMemo } from 'react';
import { useLocation, useParams } from 'react-router';
import { Audience } from '../../api/CustomQuestion/types/Audience';
import { FounderId } from '../../api/founders';
import CustomForm from '../../components/forms/custom-form';
import { UserContext } from '../../contexts/user-context';

function FounderAdditionalInfoPage() {
  const location = useLocation();
  const { founderId } = useParams<{ founderId: FounderId }>();
  const { hasAccessToAction } = useContext(UserContext);

  const { isExternalPage, hasAccessToUpdate } = useMemo(() => {
    const isExternalPage = location.pathname.includes('external');
    const hasAccessToUpdate = isExternalPage
      ? true
      : hasAccessToAction('founder.additionalInfo.update');
    return {
      isExternalPage,
      hasAccessToUpdate,
    };
  }, [hasAccessToAction, location.pathname]);

  return (
    <div>
      <CustomForm
        audience={Audience.FOUNDER_ADDITIONAL_INFO}
        responderId={founderId}
        successMessage='Additional information successfully updated.'
        hasAccessToUpdate={hasAccessToUpdate}
        isExternalPage={isExternalPage}
      />
    </div>
  );
}

export default FounderAdditionalInfoPage;
